export const UPDATE_DEVICE = 'device/UPDATE_DEVICE';
export const UPDATE_APP_ASR = 'device/UPDATE_APP_ASR';
